import { IErrorHandling, OnboardingFormFields } from '@Types/index';

export const SsnErrorMap = {
  SSN_ALREADY_EXISTS: 4051,
  EIN_IS_NOT_SSN: 80010,
  INVALID_SSN_FORMAT: 4023,
  UBO_SSN_ALREADY_EXISTS: 41198,
};

export const SSnErrorMapObject = new Map<number, IErrorHandling>([
  [
    SsnErrorMap.SSN_ALREADY_EXISTS,
    {
      errorCode: SsnErrorMap.SSN_ALREADY_EXISTS,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.SSN,
      callBack: () => {},
    },
  ],
  [
    SsnErrorMap.EIN_IS_NOT_SSN,
    {
      errorCode: SsnErrorMap.EIN_IS_NOT_SSN,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
      callBack: () => {},
    },
  ],
  [
    SsnErrorMap.INVALID_SSN_FORMAT,
    {
      errorCode: SsnErrorMap.INVALID_SSN_FORMAT,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.SSN,
      callBack: () => {},
    },
  ],
  [
    SsnErrorMap.UBO_SSN_ALREADY_EXISTS,
    {
      errorCode: SsnErrorMap.UBO_SSN_ALREADY_EXISTS,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.SSN,
      callBack: () => {},
    },
  ],
]);
